import * as Yup from 'yup';

export const createBlogSchema = Yup.object({
  title: Yup.string()
    .required('Title is required')
    .min(5, 'Title must be at least 5 characters'),
  
  content: Yup.string()
    .required('Content is required')
    .min(50, 'Content must be at least 50 characters'),
  
  // ✅ FIX: Validate as a URL string, not just any mixed type.
  image: Yup.string()
    .url('Must be a valid URL')
    .optional(),
  
  // ✨ ADDED: Validation for the required metaDescription field.
  metaDescription: Yup.string()
    .required('A meta description is required for SEO')
    .min(20, 'Meta description must be at least 20 characters'),

  published: Yup.boolean().required(),
});